import { handleActions } from "redux-actions";
import _assign from "lodash/assign";
//
import { BOOKING_DURATION_CHANGE } from "../booking/actions";
import { USER_GET } from "../auth/actionTypes";
import { AJAX_ERROR } from "../ajax";
import { REVIEWS_GET } from "../reviews/actions";
import { VIDEOS_GET } from "../videos";
import {
  MODAL_SCREEN_SHOW,
  MODAL_HIDE,
  SEARCH_EDIT,
} from "../modal/actionTypes";
import {
  AREA_SET,
  MODEL_SET,
  MODEL_SHOW,
  MODELS_GET,
  MODELS_OFFLINE_GET,
  MODELS_FAVORITE_GET,
  MODEL_GET,
  MODEL_FAVORITE,
  MODEL_UNFAVORITE,
  MODELS_VISIBLE_SET,
  MODEL_PREBOOK,
  MODELS_COUNT,
  REJECT_TIME,
} from "./actions";
import Ctrl from "./controller";

const serverState = window.initialState;

const initialState = _assign(
  {
    entities: {},
    active: null,
    unavailable: [],
    online: [],
    offline: [],
    favorite: [],
    visible: "online",
    favoriteLoaded: false,
    onlineCount: null,
    areaId: null,
  },
  serverState.models
);

export default handleActions(
  {
    [MODEL_SHOW]: Ctrl.setModel,
    [MODEL_SET]: Ctrl.setModel,
    [MODEL_PREBOOK.FULFILLED]: Ctrl.setModel,
    [MODELS_GET.PENDING]: Ctrl.getModelsPending,
    [MODELS_GET.FULFILLED]: Ctrl.getModelsFullfilled,
    [MODELS_COUNT.FULFILLED]: Ctrl.countModelsFullfilled,
    [MODELS_OFFLINE_GET.FULFILLED]: Ctrl.getModelsOfflineFullfilled,
    [MODELS_FAVORITE_GET.FULFILLED]: Ctrl.getModelsFavoriteFullfilled,
    [VIDEOS_GET.FULFILLED]: Ctrl.getVideosFullfilled,
    [MODEL_GET.FULFILLED]: Ctrl.getModelFullfilled,
    [AJAX_ERROR]: Ctrl.modelUnavailableError,
    [MODEL_FAVORITE]: Ctrl.favoriteModel,
    [MODEL_UNFAVORITE]: Ctrl.unfavoriteModel,
    [USER_GET.FULFILLED]: Ctrl.setUser,
    [MODELS_VISIBLE_SET]: Ctrl.setModelsVisible,
    [MODEL_PREBOOK.PENDING]: Ctrl.setModel,
    [BOOKING_DURATION_CHANGE]: Ctrl.changeDuration,
    [REVIEWS_GET.FULFILLED]: Ctrl.getReviewsFulfilled,
    [MODAL_SCREEN_SHOW]: Ctrl.showScreen,
    [SEARCH_EDIT]: Ctrl.editSearch,
    [MODAL_HIDE]: Ctrl.reset,
    [REJECT_TIME]: Ctrl.reset,
    [AREA_SET]: Ctrl.setArea,
  },
  initialState
);
